import { ReactNode, useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';

import { Button, FormControl, FormItem, Modal, TextInput } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';

interface FormValues {
  externalId?: string;
}

export interface ReferencesSelectExternalProps {
  value?: FormValues;
  onSubmit: (value?: FormValues) => void;
  mode: 'add' | 'update';
  trigger: ReactNode;
}

export function ReferencesSelectExternal({
  value,
  onSubmit: onSubmitProp,
  mode,
  trigger,
}: ReferencesSelectExternalProps) {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);
  const { handleSubmit, register, reset } = useForm<FormValues>({
    defaultValues: value,
  });

  const onSubmit: SubmitHandler<FormValues> = formValues => {
    setModalOpen(false);
    onSubmitProp(formValues);
  };

  return (
    <FormControl.Root>
      <Modal.Root
        open={modalOpen}
        onOpenChange={o => {
          setModalOpen(o);
          if (!o) {
            reset(value);
          }
        }}
      >
        <Modal.Trigger>{trigger}</Modal.Trigger>
        <Modal.Content>
          <FormControl.Form onSubmit={handleSubmit(onSubmit)} style={{ display: 'none' }} />

          <Modal.Header title={t(mode == 'add' ? 'common.addReference' : 'common.updateReference')} />

          <Modal.Body>
            <FormItem.Root>
              <FormItem.Label>{t('common.orderNumber')}</FormItem.Label>

              <FormItem.Control>
                <TextInput {...register('externalId')} />
              </FormItem.Control>
            </FormItem.Root>
          </Modal.Body>
          <Modal.Footer>
            <Modal.CloseButton>
              <Button variant="secondary">{t('common.cancel')}</Button>
            </Modal.CloseButton>

            <FormControl.SubmitButton asChild>
              <Button>{t(mode == 'add' ? 'common.addReference' : 'common.updateReference')}</Button>
            </FormControl.SubmitButton>
          </Modal.Footer>
        </Modal.Content>
      </Modal.Root>
    </FormControl.Root>
  );
}
